export const getIsQA = (hostname = window.location.hostname) => hostname.indexOf('wthubspot') >= 0 || hostname.indexOf('hubspotqa') >= 0;